'use strict';
import {CreateCardHOC} from '../../../components/lists/CreateCard';
import {OrganizationForm} from '../OrganizationForm';


export const CreateOrgCardComponent = CreateCardHOC(OrganizationForm, {
  showPoc: false,
});



// WEBPACK FOOTER //
// ./src/js/organizations/components/CreateOrgCard/CreateOrgCardComponent.js